
import { useState } from "react";
import { getRandomInteger, getRandomOperation, getCorrectAnswer } from '../../utils/helper_functions';
import "./index.scss"

function Quiz() {
    const [operand1,setOperand1] = useState(getRandomInteger(1,1000));
    const [operand2,setOperand2] = useState(getRandomInteger(1,1000));
    const [operation,setOperation] = useState(getRandomOperation());
    const [problemNumber,setProblemNumber] = useState(1);
    const [numberCorrect, setNumberCorrect] = useState(0);
    const [feedbackMessage, setFeedbackMessage] = useState("");

  const generateMathProblem = (operand1, operand2, operation) => {

    switch(operation){
      case "add":
         return <p className="math-problem-paragraph">
            What is the sum of <span className="operand1-text">{operand1}</span> and <span className="operand2-text">{operand2}</span>?
         </p>; 
      case  "multiply":
         return <p className="math-problem-paragraph">
              What is <span className="operand1-text">{operand1}</span> times <span className="operand2-text">{operand2}</span>?
         </p>;
       case "subtract":
         return <p className="math-problem-paragraph">
              What is <span className="operand1-text">{operand1}</span> minus <span className="operand2-text">{operand2}</span>?
         </p>;
       case "divide":
         return <p className="math-problem-paragraph">
            What is <span className="operand1-text">{operand1}</span> divided by <span className="operand2-text">{operand2}</span> (round to 2 decimal places)?
         </p>;
       default:
         break;
   }
  }

  const feedbackMsgClass = feedbackMessage.length > 0 && "is-showing";
  return (
    <div className="quiz-container">
        <div className="section-top">
            <h2 className="problem-title">Problem {problemNumber}</h2>
            {generateMathProblem(operand1,operand2,operation)}
            <div className="input-area">
              <input type="text" id="user-answer-input" />
              <button onClick={ () => {
                  let userInput = document.getElementById("user-answer-input");
                  let userAnswer = parseFloat(userInput.value);
                  let correctAnswer = getCorrectAnswer(operand1,operand2,operation);

                  console.log(userAnswer);
                  if(userAnswer === correctAnswer){
                    setFeedbackMessage("Correct! Great Job!")
                    setNumberCorrect(numberCorrect+1);
                  } else {
                    setFeedbackMessage("No, better luck next time!")
                  }

                  userInput.disabled = true;
                  setTimeout(() => {
                    setFeedbackMessage("");
                    userInput.value = "";
                    userInput.disabled = false;
                  },4000);

                  setProblemNumber(problemNumber+1);
                  setOperand1(getRandomInteger(10,500));
                  setOperand2(getRandomInteger(10,1000));
                  setOperation(getRandomOperation());

              }}>Submit</button>
            </div>
            <div className="section-feedback">
                <p className={feedbackMsgClass}>{feedbackMessage}</p>
            </div>

            <div className="section-score">
              <h2>Current Score</h2>
              <p>You've answered {numberCorrect} correct out of {problemNumber-1}</p>
            </div>
        </div>
   
    </div>
  );
}

export default Quiz;
